import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'custom-breadcrumb-component',
  standalone: false,
  templateUrl: './custom-breadcrumb-component.component.html',
  styleUrl: './custom-breadcrumb-component.component.css'
})
export class CustomBreadcrumbComponentComponent {
  @Input() breadcrumbItems: MenuItem[] = [];
  currentUrl: string = '';

  constructor(private router: Router) {
    this.router.events.subscribe(() => {
      this.currentUrl = this.router.url.split('?')[0];
    });
  }

  isCurrentRoute(route: string): boolean {
    return this.currentUrl === route;
  }
}
